// extracted by mini-css-extract-plugin
export default {"order-flow-wrapper":"OrderFlowLayout_order-flow-wrapper__3yG08"};